/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
document.addEventListener("DOMContentLoaded", function () {
  // 倒计时
  function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
  }

  let endTimeG;

  function cutDownTime() {
    let nowTime = new Date();
    let endTime = new Date(endTimeG);

    let leftTime = endTime.getTime() - nowTime.getTime();
    if (leftTime < 0) {
      setupNewCountdown();
      leftTime = 0;
    }
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60);
    leftH = leftH >= 10 ? leftH : "0" + leftH;
    leftM = leftM >= 10 ? leftM : "0" + leftM;
    leftS = leftS >= 10 ? leftS : "0" + leftS;

    return {
      hour: leftH,
      minute: leftM,
      second: leftS,
    };
  }
  function setupNewCountdown() {
    const randomHour = getRandomNum(1, 9);
    const currentTime = new Date();
    endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
  }
  let intervalId;

  function getCutDownTime() {
    setupNewCountdown();
    if (intervalId) clearInterval(intervalId);
    intervalId = setInterval(function () {
      let cutDownTimeText = cutDownTime();
      $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
      $(".sp_top_cut_down .sp_left_view .sp_minute").html(
        cutDownTimeText.minute
      );
      $(".sp_top_cut_down .sp_left_view .sp_second").html(
        cutDownTimeText.second
      );
    }, 1000);
  }

  getCutDownTime();

  let spImgList = [
  "https://cdn.shopify.com/s/files/1/0618/0061/1913/files/202412282-p1.png",
  "https://cdn.shopify.com/s/files/1/0618/0061/1913/files/20250606-img1.png?v=1749179366",
  "https://cdn.shopify.com/s/files/1/0618/0061/1913/files/20250606-img3.png?v=1749179367",
    "https://cdn.shopify.com/s/files/1/0618/0061/1913/files/202412282-p2.png",
  "https://cdn.shopify.com/s/files/1/0618/0061/1913/files/20250606-img2.png?v=1749179366",
  "https://cdn.shopify.com/s/files/1/0618/0061/1913/files/20250606-img4.png?v=1749179367"
  ]

  function mainRender() {
    $(function () {
      $("#root").css("zoom", "normal");
      let scale = document.body.clientWidth / 1080;
      $("#root").css("zoom", scale);

      window.addEventListener(
        "resize",
        (function () {
          var timer;
          return function () {
            if (timer) clearTimeout(timer);
            timer = setTimeout(function () {
              $("#root").css("zoom", "normal");
              let scale = document.body.clientWidth / 1080;
              $("#root").css("zoom", scale);
            }, 100);
          };
        })()
      );
    });

    function lazyLoadImages() {
      // 懒加载
      const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
      const config = {
        rootMargin: "0px 0px 1300px 0px",
        threshold: 0,
      };

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 当图片进入视口时
            const image = entry.target;
            const dataSrc = image.getAttribute("data-src");
            image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
            lazyLoadObserver.unobserve(image); // 停止观察该图片
          }
        });
      },
      config);

      images.forEach(function (image) {
        lazyLoadObserver.observe(image); // 开始观察每个图片
      });
    }

    function preloadImages(imageArray) {
      // 预加载
      // 检查数组数据结构
      if (Array.isArray(imageArray[0])) {
        // 处理二维数组
        imageArray.forEach((subArray) => {
          subArray.forEach((url) => {
            const img = new Image();
            img.src = url;
          });
        });
      } else {
        // 处理一维数组
        imageArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      }
    }

    lazyLoadImages();

    preloadImages(spImgList);

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") -
            250 * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });

    // IOS字体多了间距的处理 给节点添加 sp_system 类名
    // 判断当前用户是安卓端还是iOS端
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    var isAndroid = /android/i.test(userAgent);
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

    if (isAndroid) {
      console.log("Android");
    } else if (isIOS) {
      console.log("iOS");
    } else if (isPC) {
      console.log("PC");
    } else {
      $(".sp_system").css("letter-spacing", "-4px");
    }
  }

  mainRender();

  let prod = window.product
  let sp_price1 = prod[0].price;
  let sp_price2 = prod[0].compare_at_price;
  let sp_price3 = prod[1].price;
  let sp_price4 = prod[1].compare_at_price;

  function calcTotal(price, num) {
    let result = Number(price) * Number(num) / 100;
    return result.toFixed(2);
  }

  $(".sp-reduce1").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) - 1;
    if (num > 0) {
      input.value = num;
    }
    $("#sp_price1").html(calcTotal(sp_price1, input.value));
    $("#sp_price2").html(calcTotal(sp_price2, input.value));
  });
  // 字体轮播
    new Swiper('.mySwiperFree', {
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      loop: true,
    })
  $(".sp-add1").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) + 1;
    input.value = num;
    $("#sp_price1").html(calcTotal(sp_price1, input.value));
    $("#sp_price2").html(calcTotal(sp_price2, input.value));
  });
  $(".sp-reduce2").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) - 1;
    if (num > 0) {
      input.value = num;
    }
    $("#sp_price3").html(calcTotal(sp_price3, input.value));
    $("#sp_price4").html(calcTotal(sp_price4, input.value));
  });
  $(".sp-add2").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) + 1;
    input.value = num;
    $("#sp_price3").html(calcTotal(sp_price3, input.value));
    $("#sp_price4").html(calcTotal(sp_price4, input.value));
  });
   $('.selectl span').click(function(){
            $(this).addClass("on").siblings().removeClass("on");
            $(this).parent().parent().find('span#sp_price1').text($(this).data('price'))
            $(this).parent().parent().find('span#sp_price2').text($(this).data('compare'))
               let price = $(this).data('price')
             let compare = $(this).data('compare')
             let off_font = 100 - Math.ceil(price / compare * 100)
     $(this).parents('.product-box').find('.sp-brand2 span').html(off_font)
        })
    

      $('.sp-btn-style').on('click',function(){
          let id = $(this).siblings('.selectl').find('span.on').data('id');

          if($(this).attr('data-num')){
            id = $(this).siblings('.flex-bet').find('span.on').data('id');
          }
          window.location.href = '/cart/' + id + ':1'
        })
      
$(".selectl span").click(function () {
  $(this).addClass("on").siblings().removeClass("on");
  let p_img = $(this).parents(".product-box").find(".p-img")[0];
  let _numIndex = $(this).parents(".product-box").index();
  let _sizeIndex = $(this).index();
  const brand =$(this).attr('data-brand') 
  if(brand) {
     $(this).parents(".product-box").find("#sp-brand3").show();
  }else{
    $(this).parents(".product-box").find("#sp-brand3").hide();
  }
  p_img.src = spImgList[_numIndex + _sizeIndex * 3];
  p_img.srcset = spImgList[_numIndex + _sizeIndex * 3];
 
});
});
